import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { ProductoService } from 'src/app/services/catalogos/producto.service';
import { merge, of } from 'rxjs';
import { catchError, debounceTime, map, startWith, switchMap } from 'rxjs/operators';
import { TableComponent } from 'src/app/shared/components/common/tables/table/table.component';
import { AddProductoComponent } from 'src/app/modules/shared/add-producto/add-producto.component';
import { ConfirmDialogComponent } from 'src/app/shared/components/common/modals/confirm-dialog/confirm-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-lista-productos',
  templateUrl: './lista-productos.component.html',
  styleUrls: ['./lista-productos.component.sass']
})
export class ListaProductosComponent implements OnInit {

  isLoading = true;
  usuarios;

  displayedColumns = ["Acciones", "Descripcion", "Usos", "Presentacion", "Activo"]; //"patente", "aduana", "pedimento", "eta"
  vals = [
    { nombreColumna: "Acciones", campo: "", tipoChip: false },
    { nombreColumna: "Descripcion", campo: "descripcion", tipoChip: false },
    { nombreColumna: "Usos", campo: "usos", tipoChip: false },
    { nombreColumna: "Presentacion", campo: "presentacion", tipoChip: false },
    { nombreColumna: "Activo", campo: "activo", tipoChip: true }
  ];

  status = [{ id: '0', nombre: 'Inactivo', color: 'gray' }, { id: '1', nombre: 'Activo', color: 'green' }]

  getStatus(tipo, id) {
    if (tipo == "activo") {
      return this.status.find(st => st.id == id);
    }
  }
  obtenerValor(row) {
    if (typeof row === 'object' && row !== null) {
      return row.descripcion;//[val.campo]
    }
    else {
      return row;
    }
  }
  getObj(value) {
    return this.vals.find(val => val.nombreColumna === value);
  }
  AbrirMenu() {
    this.trigger.openMenu();
  }

  resultsLength = 0;
  pageSize = 10;
  searchBy = { value: "descripcion", text: "Descripcion" }
  attributes = 'attributes[0]=idProducto&attributes[1]=descripcion&attributes[2]=usos&attributes[3]=presentacion&attributes[4]=activo';
  filters = 'filters[activo][eq]=1';
  busquedasDispoible = [];

  searchOptions: any[] = [{ value: "fase", text: 'Fase' },
  { value: "movilidad", text: 'Movilidad' },
  { value: "internacional", text: 'Internacional' },
  { value: "otroServicio", text: 'Otro Servicio' },
  ];
  panelOpenState = false;

  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
  @Input() resultadoReporte;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(TableComponent, { static: false }) public table: TableComponent<any>;
  constructor(private _ps: ProductoService, private _router: Router, private _dialog: MatDialog, private _sb: MatSnackBar) { }

  ngOnInit(): void {
    // console.log(this.resultadoReporte);
    this.displayedColumns = [...this.displayedColumns];
    // this.servicios = this.resultadoReporte;

    console.log("Esta es la lista de servicios");
  }

  ngAfterViewInit() {
    this.actualizarReporte()
  }
  handleSearchChange(event) {
    console.log("Busqueda del reporte");
  }
  verMas(element) {
    console.log("Ver mas");
  }
  actualizarReporte() {
    merge(this.table.sort.sortChange, this.table ? this.table.paginator.page : [], this.table.searchValue.valueChanges.pipe(debounceTime(500)))
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoading = true;
          // let chipsFilters = this.agregarFiltros();
          return this._ps.getProductos(`${this.attributes}&${this.filters}${this.table.searchValue.value ? `&filters[${this.searchBy.value}][like]=%25${this.table.searchValue.value.replace("&", "%26")}%25` : ''}&size=${this.table.paginator.pageSize}&page=${this.table.paginator.pageIndex}`);
        }),
        map((data: any) => {
          this.isLoading = false;
          this.resultsLength = data.count;
          return data.rows
          //return [];
        }),
        catchError(() => {
          this.isLoading = false;

          return of([]);
        })
      )
      .subscribe((data: any) => {
        if (data) {
          // this._ss.setPreference("pageSize", this.table.paginator.pageSize.toString());
          this.usuarios = data;
          // this.getFiltros();

        } else {
          this.usuarios = [];
        }
      });
  }

  verifica(id) {
    // console.log(id)
    // console.log(`verificacion/${id}`);
    // this._router.navigate([`servicios/verificacion/${id}`])
  }

  edita(producto) {
    // console.log(id)
    // console.log(`editar/${id}`);
    // this._router.navigate([`servicios/registro/${id}`])
    this.showAgregaProducto(producto)
  }

  desactiva(producto) {
    this.showConfirmaDesactivar({ title: "Desctivar", message: `Confirma desactivar el producto ${producto.descripcion}`, cancelButton: "Cancelar", okButton: "Aceptar" }, producto)
  }


  agregaUsuario() {
    // this._router.navigate([`servicios/registro/new`])

  }



  async showAgregaProducto(producto) {
    const dialogRef = this._dialog.open(AddProductoComponent, {
      // panelClass: "sixtyprc-dialog",
      disableClose: false,
      maxHeight: '60%',
      data: producto
    });
    dialogRef.afterClosed().subscribe(async result => {
      try {
        console.log(result);
        if (result) {
          this.actualizarReporte()
          // this._servicioService.patchServicio(this.idServicio, { action: 3 })
          // this._snakBar.open("Servicio Finalizado!", "Aviso", { duration: 3000 })
        }
      } catch (err) {
        // console.log(err);
        // this._snakBar.open("Error al finalizar el servicio", "Error", { duration: 3000 })
      }
    })
  }

  async showConfirmaDesactivar(parametros, producto) {
    const dialogRef = this._dialog.open(ConfirmDialogComponent, {
      panelClass: "sixtyprc-dialog",
      disableClose: true,
      maxHeight: '60%',
      data: {
        confirmDialogData: {
          title: parametros.title, message: parametros.message, cancelButton: parametros.cancelButton, okButton: parametros.okButton
        }
      }
    });
    dialogRef.afterClosed().subscribe(async result => {
      try {
        console.log(result);
        if (result) {
          await this._ps.patchProducto(producto.idProducto, "deactivate", {})
          this.actualizarReporte()
        }
      } catch (err) {
        console.log(err);
        this._sb.open("Error al Desactivar el producto", "Error", { duration: 3000 })
      }
    })
  }

}
